import { render, staticRenderFns } from "./DatasetItem.vue?vue&type=template&id=35cd49f5&"
import script from "./DatasetItem.vue?vue&type=script&lang=js&"
export * from "./DatasetItem.vue?vue&type=script&lang=js&"
import style0 from "./DatasetItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports